import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, useAppSelector } from "../redux/AppStore";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { UserVerifyFromPostCodeThunk } from "../redux/slice/UpdateTrackingAddressSlice";
import VerifyAddressComponent from "./VerifyAddressDialog";
import OrderDetailMapComponent from "./Map/OrderDetailMapComponent";
import TrackProgressInfo from "./TrackProgress";
import { DownloadPodThunk } from "../redux/slice/TrackingSlice";
import { SHOW_REFERENCE, trackingSettingOn, browserTimeZone } from "./trackingSettings";

export default function OrderDetailInfoComponent() {
  const trackinginfo = useSelector((state: RootState) => state.tracking.trackingdata);
  const isloading = useSelector((state: RootState) => state.tracking.isLoading);
  const getEta = useSelector((state: RootState) => state.tracking.getEta);
  const getEtaDate = useSelector((state: RootState) => state.tracking.getEtaDate);
  const getEtaTime = useSelector((state: RootState) => state.tracking.getEtaTime);
  const deliverydate = useSelector((state: RootState) => state.tracking.deliverydate);
  const getEtaMonth = useSelector((state: RootState) => state.tracking.getEtaMonth);
  const trackingaddress = useSelector((state: RootState) => state.tracking.trackingAddress.tracking_address);
  const trackingNumber = useSelector((state: RootState) => state.tracking.trackingNum);
  const trackingStatus = useSelector((state: RootState) => state.tracking.trackingstatus);
  const isInternal = useAppSelector((state: RootState) => state.tracking.isinternal);
  const shipmentType = useAppSelector((state: RootState) => state.tracking.shipmentType);
  const SearchByLoadIdentity = useAppSelector((state: RootState) => state.tracking.SearchByLoadIdentity);
  const driverInfo = useAppSelector((state: RootState) => state.tracking.driverInfo);
  const [verifyRequested, setVerifyRequested] = useState(false);
  const shipmentStatus = useAppSelector((state: RootState) => state.updateAddress.status);
  const companyInfo = useAppSelector((state: RootState) => state.tracking.companyinfo);
  const postCode = useAppSelector((state: RootState) => state.tracking.userPostCode);
  const location = useLocation();
  const hasToken = Boolean(new URLSearchParams(location.search).get("token"));
  const isValidated = shipmentStatus === true && postCode && postCode.trim() !== '';
  // BR-1920: the API decides (BR-1881) — fullAccess = it sent the full record. Replaces the company 19299 bypass.
  const fullAccess = useAppSelector((state: RootState) => state.tracking.fullAccess);
  const canViewRestricted = fullAccess || isValidated || hasToken;
  // BR-1929: the customer's reference, for companies that switch it on (IT Sameday). Empty until verified.
  const customerRef = useAppSelector((state: RootState) => state.tracking.customerRef);
  const showReference = trackingSettingOn(companyInfo, SHOW_REFERENCE) && customerRef.trim() !== '';
  const [dates, setDates] = useState<string[]>([]);
  const [loadIdentity, setloadIdentity] = useState('');
  let comdata: any = '';
  let comdatainfo: any = '';
  useEffect(() => {
    setDates(Object.keys(trackinginfo));
  }, [trackinginfo]);
  if (companyInfo != null && Object.keys(companyInfo).length != 0 && companyInfo.action_on_tracking != null) {
    comdata = companyInfo.action_on_tracking.includes('delivery_address');
    comdatainfo = companyInfo.action_on_tracking.includes('download_pod');

  }

  const dispatch = useDispatch<AppDispatch>();
  const userPostcode = useSelector((state: RootState) => state.tracking.userPostCode);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const openDialog = () => {
    setIsDialogOpen(true);
  };
  const closeDialog = () => {
    setIsDialogOpen(false);
  };
  const getPostcodeForLoad = (targetLoadId: string) => {
    if (!Array.isArray(trackingaddress)) return ''; // Prevent iteration on undefined or null

    for (let d of trackingaddress) {
      if (d.group_type == "NEXT") {
        if (d.load_identity == targetLoadId && d.shipment_service_type == 'D') {
          return d.post_code;
        }
      } else {
        if (d.shipment_ticket == targetLoadId) {
          return d.post_code;
        }
      }
    }
    return '';
  };
  const getPostcodeForshipmentID = (targetLoadId: string) => {
    if (!Array.isArray(trackingaddress)) return '';

    for (let d of trackingaddress) {
      if (d.load_identity == targetLoadId && d.shipment_service_type == 'D') {
        return d.post_code;
      }
    }

    return '';
  };
  const formatTime = (value: string) => {
    if (!value) return '';
    const parts = value.split(':');
    if (parts.length < 2) return value;
    return `${parts[0]}:${parts[1]}`;
  };
  const getExpectedTimeText = (startTime?: string, endTime?: string, serviceType?: string) => {
    if (!startTime || !endTime) return '';
    const label = serviceType === 'P' ? 'Pickup' : serviceType === 'D' ? 'Delivery' : 'Service';
    const start = formatTime(startTime);
    const end = formatTime(endTime);
    if (!start || !end) return '';
    if (start === end) {
      return `${label} expected at ${start}`;
    }
    return `${label} expected Between ${start} to ${end}`;
  };
  const delevrydates = () => {
    const date = new Date(deliverydate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  }
  let dts = delevrydates();
  const expectedTimeRecords = Array.isArray(trackingaddress)
    ? trackingaddress
        .map(t => ({
          record: t,
          text: getExpectedTimeText(t.start_time, t.end_time, t.shipment_service_type),
        }))
        .filter(({ text }) =>
          canViewRestricted &&
          text
        )
    : [];
  const hasAnyDriverAssigned = expectedTimeRecords.some(
    ({ record }) => record.assigned_driver !== '' && record.assigned_driver !== null && record.assigned_driver !== 0
  );
  const isRouteStarted = String(driverInfo?.is_route_started ?? '0') === '1';
  const [cstatus, setCStatus] = useState('');
  useEffect(() => {
    setDates(Object.keys(trackinginfo));
  }, [trackinginfo]);
  useEffect(() => {
    if (dates.length != 0) {
      for (let v of dates) {
        for (let date of trackinginfo[v]) {
          setCStatus(date.code_text);
          setloadIdentity(date.load_identity);
          break;
        }
        break;
      }
    }
  }, [dates])
  const currentLoadId = loadIdentity || trackingNumber;
  const matchedPostcode = getPostcodeForLoad(currentLoadId);
  const UserAddress = async () => {
    // BR-1920: was company 19299 only. Anyone the API already verified uses the postcode it sent back.
    if (fullAccess && matchedPostcode !== '' && trackingStatus === 'success') {
      try {
        const result = await dispatch(
          UserVerifyFromPostCodeThunk({
            trackingNo: String(trackingNumber).trim(),
            postCode: String(matchedPostcode).trim(),
            mobileNo: String(matchedPostcode).trim(),
            verifyfrom: "D",
            verifStatus: "5fe69c95ed70a9869d9f9af7d8400a6673bb9ce9"
          })
        ).unwrap();

        if (result?.status !== false) {
          openDialog();
        } else {
          closeDialog();
        }
      } catch {
        closeDialog();
      }
      return;
    }

    if (hasToken) {
      openDialog();
      return;
    }

    if (postCode === "") {
      alert("please provide postcode or phone digits");
      return;
    }

    if (userPostcode !== "" && trackingStatus === 'success') {
      try {
        const result = await dispatch(
          UserVerifyFromPostCodeThunk({
            trackingNo: String(trackingNumber),
            postCode: String(userPostcode),
            mobileNo: String(userPostcode),
            verifyfrom: "D",
            verifStatus: "5fe69c95ed70a9869d9f9af7d8400a6673bb9ce9"
          })
        ).unwrap();

        if (result?.status !== false) {
          openDialog();
        } else {
          closeDialog();
        }
      } catch {
        closeDialog();
      }
    }
  };

  const podpath = useAppSelector((state: RootState) => state.tracking.downloadPod);
  const matchedPostcodeid = getPostcodeForshipmentID(currentLoadId);
  const podIdentity = hasToken && loadIdentity ? loadIdentity : trackingNumber;
  const hasSameGroup = Array.isArray(trackingaddress)
    ? trackingaddress.some(t => t.group_type === 'SAME')
    : false;
  const downloaPod = async () => {
    // BR-1920: was companies 20516 / 19299 only — the API already checked the visitor.
    if (fullAccess) {
      if (podpath == '') {
        const result = await dispatch(
          DownloadPodThunk({
            identity: podIdentity,
            delivery_postcode: String(matchedPostcodeid),
            origin: "tracking",
            tracking_type: "pod",
            pod_origin: "",
            endPointUrl: "/searchDeliveryAddress",
            timezone_name: browserTimeZone()
          })
        ).unwrap();
        if (result.status == "success" && result.pod_path !== '') {
          window.open(result.pod_path, '_blank');
        }
      }
      if (!isloading && podpath !== '') {
        //console.log(podpath);
        window.open(podpath, '_blank');
      }
    } else {
      if (!isValidated && !hasToken) {
        alert('please provide your postcode or last 4 digits of your phone number to validate your identity and view this information');
        return;
      }
      if (podpath == '') {
        const result = await dispatch(
          DownloadPodThunk({
            identity: podIdentity,
            delivery_postcode: String(matchedPostcodeid),
            origin: "tracking",
            tracking_type: "pod",
            pod_origin: "",
            endPointUrl: "/searchDeliveryAddress",
            timezone_name: browserTimeZone()
          })
        ).unwrap();
        if (result.status == "success" && result.pod_path !== '') {
          window.open(result.pod_path, '_blank');
        }
      }
      if (!isloading && podpath !== '') {
        //console.log(podpath);
        window.open(podpath, '_blank');
      }
    }
  }


  // BR-1920: the delivery date the old page showed (legacy track.js addEtaDetails). getEtaTime holds the YEAR.
  const finishedCodes = ["Delivery Carded", "Delivery Return", "Collection Carded", "Partly Collected", "Partly Delivered", "Delivered", "DELIVERED"];
  const showExpectedDelivery = Boolean(getEtaDate) && deliverydate && deliverydate !== 'N/A' && !dts
    && !finishedCodes.includes(cstatus);
  // BR-1929: the old page said "Delivery Not Scheduled Yet" when the expected date had passed and the parcel was not
  // finished (legacy track.js:1426). React just hid the box.
  const showNotScheduled = Boolean(deliverydate) && deliverydate !== 'N/A' && dts
    && !finishedCodes.includes(cstatus) && cstatus !== 'Cancelled';
  let relevantCodes = ["Delivery Carded", "Delivery Return", "Collection Carded", "Partly Collected", "Partly Delivered", "Delivered", "Cancelled", "DELIVERED"].includes(cstatus);

  const sameDayTimeEntries = Array.isArray(trackingaddress)
    ? trackingaddress
        .filter(t => t.group_type === 'SAME')
        .map((t, index) => ({
          record: t,
          index,
          executionOrder: Number(t.execution_order ?? index),
          shipmentOrder: Number(t.shipment_order ?? Number.NaN),
        }))
        .sort((a, b) => {
          const aOrder = Number.isFinite(a.shipmentOrder) ? a.shipmentOrder : a.executionOrder;
          const bOrder = Number.isFinite(b.shipmentOrder) ? b.shipmentOrder : b.executionOrder;
          if (aOrder === bOrder) return a.index - b.index;
          return aOrder - bOrder;
        })
        .map(item => {
          const t = item.record;
          const statusLabel = t.shipment_service_type === 'P' ? 'Pickup' : 'Delivery';
          const statusText = String(t.currentStatus || '').toLowerCase();
          const isCompletedStatus =
            statusText === 'collected' ||
            statusText === 'delivered';
          const estimatedTime = formatTime(t.estimatedTime ?? '');
          const baseTime = formatTime(t.start_time || t.end_time);
          const expectedTimeText = getExpectedTimeText(t.start_time, t.end_time, t.shipment_service_type);
          const displayTimeText = String(t.is_shipment_routed ?? '0') === '0'
            ? expectedTimeText
            : (statusText !== ''
                ? (estimatedTime
                    ? (isCompletedStatus
                        ? `${statusLabel} at ${estimatedTime}`
                        : `${statusLabel} Expected at ${estimatedTime}`)
                    : expectedTimeText)
                : (estimatedTime
                    ? `${statusLabel} Expected at ${estimatedTime}`
                    : expectedTimeText));
          return {
            record: t,
            displayTimeText,
            shipmentOrder: item.shipmentOrder,
            isPickup: t.shipment_service_type === 'P',
            isDelivered: t.tracking_code === "DELIVERYSUCCESS",
          };
        })
        .reduce((acc, item) => {
          let pickupCounter = acc.pickupCounter;
          let dropCounter = acc.dropCounter;
          const hasShipmentOrder = Number.isFinite(item.shipmentOrder);
          const displayOrder = hasShipmentOrder ? Number(item.shipmentOrder) + 1 : null;
          let markerLabel = '';
          if (item.isPickup) {
            pickupCounter += 1;
            const labelNumber = displayOrder ?? pickupCounter;
            markerLabel = `P${labelNumber}`;
          } else {
            dropCounter += 1;
            const labelNumber = displayOrder ?? dropCounter;
            markerLabel = `D${labelNumber}`;
          }
          acc.items.push({ ...item, markerLabel });
          return { items: acc.items, pickupCounter, dropCounter };
        }, { items: [] as Array<{
          record: any;
          displayTimeText: string;
          shipmentOrder: number;
          isPickup: boolean;
          isDelivered: boolean;
          markerLabel: string;
        }>, pickupCounter: 0, dropCounter: 0 })
        .items
    : [];

  return (
    <div >
      <div className="tab-pane fade show active" id="Order_Details" role="tabpanel" aria-labelledby="Order_D">
        <div className="bodyTab">
          <div className="tab_areaLeft">
            <div className="orderlistingCnt">
              <div className="LeftDatatOrder">
                <ul>
                  <li key={dates[dates.length - 1]}>
                    <div className="listingContainer">
                      <div className="icon_data">
                        <i className="fa-regular fa-calendar-days"></i>
                      </div>
                      <div className="view_data">
                        <span className="small_text">
                          Booking Date
                        </span>
                        <span className="large_text">
                          {dates[dates.length - 1]}
                        </span>
                      </div>

                    </div>
                  </li>
                  {showReference && (
                    <li key="customer-reference">
                      <div className="listingContainer">
                        <div className="icon_data">
                          <i className="fa-solid fa-hashtag"></i>
                        </div>
                        <div className="view_data">
                          <span className="small_text">Reference</span>
                          <span className="large_text">{customerRef}</span>
                        </div>
                      </div>
                    </li>
                  )}
                     {trackingaddress &&
                      trackingaddress.map((t, idx) => {
                    if (isRouteStarted) {
                        return null;
                      }
                      const hasDriver =
                        t.assigned_driver !== '' &&
                        t.assigned_driver !== 0 &&
                        t.is_shipment_routed != 0 
                      return (
                        (canViewRestricted &&  t.shipment_ticket == trackingNumber
                           && t.group_type === 'SAME'
                           && isRouteStarted
                          ) && (
                          <li key={idx}>
                            <div className="listingContainer">
                              <div className="icon_data">
                          <i className="fa-solid fa-user"></i>
                         </div>
                              <div className="view_data">
                                {hasDriver ? (
                                  <span className="large_text">Driver allocated</span>
                                ) : (
                                  <span className="large_text">Waiting to be scheduled</span>
                                )}
                              </div>
                            </div>
                          </li>
                          
                        )
                      )
                    })}
                  {sameDayTimeEntries.map((item, idx) => {
                    if (!(canViewRestricted && item.displayTimeText)) {
                      return null;
                    }
                    const t = item.record;
                    const color = item.isDelivered ? "#0d47a1" : (item.isPickup ? "#1e88e5" : "#d32f2f");
                    const backgroundColor = item.isDelivered ? "#0d47a1" : "#ffffff";
                    const textColor = item.isDelivered ? "#ffffff" : color;
                    return (
                      <li key={idx}>
                        <div className="listingContainer">
                          <div className="icon_data">
                            <div
                              style={{
                                width: 28,
                                height: 28,
                                borderRadius: "50%",
                                backgroundColor,
                                border: `2px solid ${color}`,
                                color: textColor,
                                fontWeight: 700,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                              }}
                              title={item.isPickup ? "Pickup" : "Drop"}
                            >
                              {item.markerLabel}
                            </div>
                          </div>
                          <div className="view_data">
                            <span className="large_text">{t.shipment_address} {t.post_code}</span>
                            <span className="large_text">{item.displayTimeText}</span>
                          </div>
                        </div>
                      </li>
                    );
                  })}

                  {trackingaddress &&
                    trackingaddress.map((t, idx) => {
                      return (
                        (canViewRestricted &&
                          t.group_type === 'NEXT' &&
                          t.shipment_service_type === 'D') && (
                          <li key={`${t.load_identity}-${idx}`}>
                            <div className="listingContainer">
                              <div className="icon_data">
                                <i className="fa-solid fa-location-dot"></i>
                              </div>
                              <div className="view_data">
                                <span className="small_text">Address</span>
                                <span className="large_text">
                                  {t.shipment_address} {t.post_code}
                                </span>
                              </div>
                            </div>
                          </li>
                        )
                      )
                    })}

                  <li>
                  </li>
                </ul>
              </div>
              {hasSameGroup && (
                <>
                  {canViewRestricted && (
                    <OrderDetailMapComponent />
                  )}
                </>
              )}
              
            </div>
          </div>
          <div className="tab_areaRight">
            {showNotScheduled && (
              <div className="time-datebox expected_delivery not_scheduled">
                <div className="exp-delivery-headding">Delivery Not Scheduled Yet</div>
              </div>
            )}
            {showExpectedDelivery && (
              <div className="time-datebox expected_delivery">
                <div className="exp-delivery-headding">Expected Delivery by</div>
                <div className="main-calender-box"><div className="date-modal">
                  <div className="date-number">{getEtaDate}</div>
                  <div className="date-month"><div>{getEtaMonth}</div><div>{getEtaTime}</div></div>
                </div></div>
              </div>
            )}
            <div className="listing">
              {(isInternal == 1 || shipmentType == "SAME" && !hasToken) && (SearchByLoadIdentity == false)  && (companyInfo.action_on_tracking == null || comdata === true) && cstatus != 'Delivered'  &&
                <><button type="button" data-bs-toggle="modal" onClick={UserAddress}>Update or Verify Delivery Address</button><VerifyAddressComponent visible={isDialogOpen} setVisible={closeDialog} /></>
              }
              {(isInternal == 1 || shipmentType == "SAME" || hasToken) && (companyInfo.action_on_tracking == null || comdatainfo === true) &&
                <button type="button" onClick={downloaPod}>Download POD</button>
              }
            </div>
          </div>
        </div>
      </div>
      <div className="track_pro_mobile">
        <h3>Tracking Progress</h3>
        <TrackProgressInfo />
      </div>
      <div className="modal fade" id="alerts_box" aria-hidden="true" aria-labelledby="alerts_boxLabel" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal fade" id="alerts_box" aria-hidden="true" aria-labelledby="alerts_boxLabel">
          <div className="modal-dialog modal-sm connect_with">
            <div className="modal-content">
              <div className="modal-body alerts_body">
                <div className="alerts_Container">
                  <div className="faces">
                    <div className="yep face">
                      <div className="inside">
                        <div className="eye"></div>
                        <div className="eye"></div>
                        <div className="mouth"></div>
                      </div>
                    </div>
                    <div className="nonope noface">
                      <div className="noinside">
                        <div className="noeye"></div>
                        <div className="noeye"></div>
                        <div className="nomouth"></div>
                      </div>
                    </div>
                  </div>
                  <div className="alerts_text">
                    <span>Address Verifiction Success!</span>
                  </div>
                </div>
                <div className="alerts_ok">
                  <button type="button" className="btn btn-primary" data-bs-dismiss="modal">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
